import { useContext } from 'react';
import { VersionContext } from 'src/contexts/version-context';

export const useVersion = () => useContext(VersionContext);
